import { Component, OnInit } from '@angular/core';
import { OrganizationSetupCommon } from '../organization-setup.common';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-company-config',
  templateUrl: './company-config.component.html',
  styleUrls: ['./company-config.component.css']
})
export class CompanyConfigComponent implements OnInit {
  modalFormObj:any;
  modalForm:any;
  modalStatus:any;
  formSubmitted=false;
  formErrors = OrganizationSetupCommon.companyConfigFormErrors;
  formValidationMessages = OrganizationSetupCommon.companyConfigFormValidationMessages;

  isEditable = false;

  toggleEdit(){
    this.isEditable =  !this.isEditable;
    this.enableEdit();
  }
  enableEdit(){
    console.log(this.isEditable)
    if(this.isEditable){
      this.modalForm.get('artCreditHours').enable();
      this.modalForm.get('artMonthlyLeaveDays').enable();
      this.modalForm.get('artMonthlyWorkingDays').enable();
      this.modalForm.get('artWeeklyWorkingDays').enable();
      this.modalForm.get('artWorkingHours').enable();
      this.modalForm.get('empCreditHours').enable();
      this.modalForm.get('empMonthlyLeaveDays').enable();
      this.modalForm.get('empMonthlyWorkingDays').enable();
      this.modalForm.get('empWeeklyWorkingDays').enable();
      this.modalForm.get('empWorkingHours').enable();
    }else{
      this.modalForm.get('artCreditHours').disable();
      this.modalForm.get('artMonthlyLeaveDays').disable();
      this.modalForm.get('artMonthlyWorkingDays').disable();
      this.modalForm.get('artWeeklyWorkingDays').disable();
      this.modalForm.get('artWorkingHours').disable();
      this.modalForm.get('empCreditHours').disable();
      this.modalForm.get('empMonthlyLeaveDays').disable();
      this.modalForm.get('empMonthlyWorkingDays').disable();
      this.modalForm.get('empWeeklyWorkingDays').disable();
      this.modalForm.get('empWorkingHours').disable();
    }
  }

  constructor(private OrganizationSetupService:OrganizationSetupService,private fb: FormBuilder,private modalService: NgbModal,
    private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.initModalForm();
    this.loadCompanyConfig();
    this.enableEdit();
  }

  loadCompanyConfig(){
    this.OrganizationSetupService.getCompanyConfig()
    .subscribe(res => {
      console.log(res);
      if(res == {}){
        this.modalStatus='add'
      }else{
        this.modalStatus='edit'
      }
      // this.modalFormObj = res;
      this.setValueToModalForm(res)
    });
  }

  initModalForm(){
    this.modalForm = this.fb.group({
      id:[''],
      artCreditHours: ['', [Validators.required]],
      artMonthlyLeaveDays: ['', [Validators.required]],
      artMonthlyWorkingDays: ['', [Validators.required]],
      artWeeklyWorkingDays: ['', [Validators.required]],
      artWorkingHours: ['', [Validators.required]],
      empCreditHours: ['', [Validators.required]],
      empMonthlyLeaveDays: ['', [Validators.required]],
      empMonthlyWorkingDays: ['', [Validators.required]],
      empWeeklyWorkingDays: ['', [Validators.required]],
      empWorkingHours: ['', [Validators.required]],
    });
  }

  // Modal Code
  openModal(content,status) {
    this.modalStatus = status;
    if(!(this.modalStatus=='edit')){
      this.resetModalForm();
    }
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size: 'md',windowClass : "animate__animated animate__slideInUp animate__faster"}).result.then((result) => {
    }, (reason) => {
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  resetModalForm(){
    this.formSubmitted = false;
    this.modalForm.reset();
  }


  onSaveClick(){
    console.log(this.modalForm.value);
    this.formSubmitted=true;
    this.logValidationErrors(this.modalForm);
    if(this.modalForm.valid){
      this.OrganizationSetupService.saveCompanyConfig(this.modalForm.value)
      .subscribe(resp => {
        console.log(resp);
        this.setValueToModalForm(resp);
        this.toggleEdit();
      this.commonMessageService.swalAlertWithIcon('','Saved Successfully!','success')
      })
    }
  }

  onUpdateClick(){
    this.formSubmitted=true;
    this.logValidationErrors(this.modalForm);
    if(this.modalForm.valid){
      this.OrganizationSetupService.updateCompanyConfig(this.modalForm.value)
      .subscribe(resp => {
        console.log(resp);
        this.setValueToModalForm(resp);
        this.toggleEdit();
        this.commonMessageService.swalAlertWithIcon('','Updated Successfully!','success')
      })
    }
  }

  // ----------------------------

  setValueToModalForm(modalObj){
    console.log(modalObj);
    this.modalForm.patchValue({
      id:modalObj.id,
      artCreditHours: modalObj.artCreditHours,
      artMonthlyLeaveDays: modalObj.artMonthlyLeaveDays,
      artMonthlyWorkingDays: modalObj.artMonthlyWorkingDays,
      artWeeklyWorkingDays: modalObj.artWeeklyWorkingDays,
      artWorkingHours: modalObj.artWorkingHours,
      empCreditHours: modalObj.empCreditHours,
      empMonthlyLeaveDays: modalObj.empMonthlyLeaveDays,
      empMonthlyWorkingDays: modalObj.empMonthlyWorkingDays,
      empWeeklyWorkingDays: modalObj.empWeeklyWorkingDays,
      empWorkingHours: modalObj.empWorkingHours,
    });

    console.log(this.modalForm.value);
  }



  //Setting
  changeModalFormObjList(modalFormObj){
    if(this.modalStatus=='add'){
      // this.modalFormObjList.push(modalFormObj);
    }
    if(this.modalStatus=='edit'){
      // var index = this.modalFormObjList.findIndex(item => item.id === modalFormObj.id)
      // this.modalFormObjList.splice(index, 1, modalFormObj);
    }
  }


  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        console.log('Key = ' + key + ' && Value = ' + abstractControl.value);
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            console.log(errorKey)
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }


}
